import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import * as domiciliosService from '../servicios/domiciliosService'
import LinkButton from '../ui/LinkButton'
import './administrar-domicilios.css'
import DatosPersonales from './DatosPersonales'
import Hero from './Hero'

const Perfil = ({ cambiarImagenPerfil, buscar }) => {
  const [domicilios, setDomicilios] = useState([])
  const { loginDataContext: { idUsuario, tipoUsuario, tipo } = {} } = useAuth()

  const navigate = useNavigate()

  const handleSeleccionDomicilio = (idDomicilio) => {
    navigate('/AdministrarDomicilios', { state: { domicilio: String(idDomicilio) } })
  }

  const searchMethod = async () => {
    if (!idUsuario) return
    const { data } = await domiciliosService.buscarTodas(idUsuario, tipoUsuario)
    setDomicilios(data)
  }

  useEffect(() => {
    searchMethod()
  }, [buscar, idUsuario])

  return (
    <div>
      <Hero cambiarImagenPerfil={cambiarImagenPerfil} />

      <hr className="hr-blue w-70"></hr>

      <DatosPersonales />

      <div className="row mt-4">
        <div className="col-12 col-lg">
          <h3>Seguridad</h3>
          <div className="ml-2">
            <ul>
              <li className="li-datos-perfil">
                <span className="d-flex">
                  {/* <p> Tu cuenta es de tipo Empresa. Para cambiar tu contraseña debes hacerlo desde <a href="https://e-buyplace.com">aquí</a></p> */}

                  {tipo === 'P' ? (
                    <LinkButton className="btn btn-sign-in" to={'/password'}>
                      Cambiar mi contraseña
                    </LinkButton>
                  ) : (
                    <p>
                      Tu cuenta es de tipo Empresa. Para cambiar tu contraseña debes hacerlo desde{' '}
                      <a href="https://e-buyplace.com">aquí</a>
                    </p>
                  )}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-1"></div>

        <div className="col-12 col-lg">
          <h3>Domicilios</h3>
          {/* EN LOGIN NO SE LE EXIGE UN DOMICILIO AL USUARIO POR LO QUE TIENE QUE CARGARLOS DESDE ESTA PANTALLA */}
          <div className="ml-2">
            <>
              {tipoUsuario !== 'A' && (
                <button
                  className="btn btn-outline-primary mb-2"
                  onClick={() => navigate('/AdministrarDomicilios', { state: { nuevo: '1' } })}
                >
                  Agregar domicilio
                </button>
              )}
              {domicilios.length === 0 ? (
                <>
                  <h4>No hay domicilios disponibles...</h4>
                </>
              ) : (
                <GenericSelect
                  options={domicilios.map((d) => ({
                    key: d.idUsuarioDomicilio,
                    value: d.idUsuarioDomicilio,
                    label: d.calle
                  }))}
                  onChange={(e) => {
                    handleSeleccionDomicilio({
                      target: e,
                      name: 'domicilio'
                    })
                  }}
                  placeholder="Selecciona un domicilio"
                  id="domicilio"
                />
              )}
            </>
          </div>
        </div>
      </div>
    </div>
  )
}

Perfil.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired,
  buscar: PropTypes.bool.isRequired
}

export default Perfil
